import React, { useState, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  FormHelperText,
  Button,
  Autocomplete,
  Tooltip,
  Box,
} from "@mui/material";
import "../component/pages/Job/ProcessTable.css";
import ClearIcon from "@mui/icons-material/Clear";
import { machineData, processList, toolListBoring } from "./Data";
import {
  formatDecimalHoursToHoursMinutes,
  formatDecimalMinutesToMinutesSeconds,
  formatMinutesSecondsToDecimal,
} from "../utils/timeHelper";

function BoringTable({
  handleDeleteRow,
  processTableData,
  handleTextFieldChange,
  processTableErrors,
  containerIndex,
  handleAddRow,
  handleValidation,
  ToolSelect,
  handleOpenToolModal,
}) {
  return (
    <>
      <Table sx={{ minWidth: 1500 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Sr.No</TableCell>
            <TableCell align="center">Process</TableCell>
            <TableCell align="center">Description</TableCell>
            <TableCell align="center">Machine Name</TableCell>
            <TableCell align="center">Tooling Used</TableCell>
            <TableCell align="center">Tooling Size</TableCell>
            <TableCell align="center">Width</TableCell>
            <TableCell align="center">Length</TableCell>
            <TableCell align="center">DC</TableCell>
            <TableCell align="center">MR</TableCell>
            <TableCell align="center">NOH</TableCell>
            <TableCell align="center">Required Dimension</TableCell>
            <TableCell align="center">NOP</TableCell>
            <TableCell align="center">FPP</TableCell>
            <TableCell align="center">Estimated CT(min)</TableCell>
            <TableCell align="center">EST.HRS</TableCell>
            <TableCell align="center">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {processTableData &&
            processTableData.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                <TableCell align="center">{rowIndex + 1}</TableCell>

                <TableCell align="center">
                  <Autocomplete
                    disablePortal
                    className="input"
                    id={`process-${rowIndex}`}
                    options={processList}
                    getOptionLabel={(option) => option}
                    value={row.process}
                    onChange={(e, newValue) =>
                      handleTextFieldChange(
                        { target: { value: newValue } },
                        rowIndex,
                        "process",
                        containerIndex,
                        "Boring"
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Process"
                        size="small"
                        name={`process-${rowIndex}`}
                        className="input"
                        error={processTableErrors[rowIndex]?.process}
                      />
                    )}
                  />
                  <FormHelperText error={processTableErrors[rowIndex]?.process}>
                    {processTableErrors[rowIndex]?.process
                      ? "This field is required"
                      : ""}
                  </FormHelperText>
                </TableCell>
                <TableCell align="center">
                  <TextField
                    label="Description"
                    className="input"
                    size="small"
                    name={`description-${rowIndex}`}
                    value={row.description}
                    onChange={(e) =>
                      handleTextFieldChange(
                        e,
                        rowIndex,
                        "description",
                        containerIndex,
                        "Boring"
                      )
                    }
                    error={processTableErrors[rowIndex]?.description}
                    helperText={
                      processTableErrors[rowIndex]?.description
                        ? "This field is required"
                        : ""
                    }
                  />
                </TableCell>
                <TableCell align="center">
                  <Autocomplete
                    disablePortal
                    className="input"
                    id={`machineName-${rowIndex}`}
                    options={machineData}
                    getOptionLabel={(option) => option}
                    value={row.machineName}
                    onChange={(e, newValue) =>
                      handleTextFieldChange(
                        { target: { value: newValue } },
                        rowIndex,
                        "machineName",
                        containerIndex,
                        "Boring"
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Machine Name"
                        size="small"
                        name={`machineName-${rowIndex}`}
                        className="input"
                        error={processTableErrors[rowIndex]?.machineName}
                      />
                    )}
                  />
                  <FormHelperText
                    error={processTableErrors[rowIndex]?.machineName}
                  >
                    {processTableErrors[rowIndex]?.machineName
                      ? "This field is required"
                      : ""}
                  </FormHelperText>
                </TableCell>
                <TableCell align="center">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {/* Use the ToolSelect component directly instead of Autocomplete */}
                    <ToolSelect
                      containerIndex={containerIndex}
                      rowIndex={rowIndex}
                      processName="Boring"
                      value={row.toolingUsed}
                      onChange={handleTextFieldChange}
                    />
                    {/* <Tooltip title="Add Custom Tool" arrow placement="top">
                      <IconButton
                        size="small"
                        onClick={() =>
                          handleOpenToolModal(
                            containerIndex,
                            rowIndex,
                            "Milling"
                          )
                        }
                        sx={{
                          backgroundColor: "#f5f5f5",
                          "&:hover": {
                            backgroundColor: "#e0e0e0",
                          },
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip> */}
                  </Box>
                  <FormHelperText
                    error={
                      processTableErrors[containerIndex]?.[rowIndex]
                        ?.toolingUsed
                    }
                  >
                    {processTableErrors[containerIndex]?.[rowIndex]?.toolingUsed
                      ? "This field is required"
                      : ""}
                  </FormHelperText>
                </TableCell>

                <TableCell align="center">
                  <TextField
                    label="Tooling Size"
                    className="fixed-width-input"
                    size="small"
                    name={`toolingSize-${rowIndex}`}
                    value={row.toolingSize}
                    onChange={(e) =>
                      handleTextFieldChange(
                        e,
                        rowIndex,
                        "toolingSize",
                        containerIndex,
                        "Boring"
                      )
                    }
                    error={processTableErrors[rowIndex]?.toolingSize}
                    helperText={
                      processTableErrors[rowIndex]?.toolingSize
                        ? "This field is required"
                        : ""
                    }
                  />
                </TableCell>

                {/* Width Field */}
                <TableCell align="center">
                  <TextField
                    label="Width"
                    className="fixed-width-input"
                    size="small"
                    name={`width-${rowIndex}`}
                    value={row.width}
                    onChange={(e) =>
                      handleTextFieldChange(
                        e,
                        rowIndex,
                        "width",
                        containerIndex,
                        "Boring"
                      )
                    }
                    error={processTableErrors[rowIndex]?.width}
                    helperText={
                      processTableErrors[rowIndex]?.width
                        ? "This field is required"
                        : ""
                    }
                  />
                </TableCell>

                {/* Length Field */}
                <TableCell align="center">
                  <TextField
                    label="Length"
                    className="fixed-width-input"
                    size="small"
                    name={`length-${rowIndex}`}
                    value={row.length}
                    onChange={(e) =>
                      handleTextFieldChange(
                        e,
                        rowIndex,
                        "length",
                        containerIndex,
                        "Boring"
                      )
                    }
                    // error={processTableErrors[rowIndex]?.length}
                    // helperText={
                    //   processTableErrors[rowIndex]?.length
                    //     ? "This field is required"
                    //     : ""
                    // }
                  />
                </TableCell>

                <TableCell align="center">
                  <TextField
                    label="DC"
                    className="fixed-width-input"
                    size="small"
                    name={`dc-${rowIndex}`}
                    value={row.dc}
                    onChange={(e) =>
                      handleTextFieldChange(
                        e,
                        rowIndex,
                        "dc",
                        containerIndex,
                        "Boring"
                      )
                    }
                    error={processTableErrors[rowIndex]?.dc}
                    helperText={
                      processTableErrors[rowIndex]?.dc
                        ? "This field is required"
                        : ""
                    }
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    label="MR"
                    className="fixed-width-input"
                    size="small"
                    name={`mr-${rowIndex}`}
                    value={row.mr}
                    onChange={(e) =>
                      handleTextFieldChange(
                        e,
                        rowIndex,
                        "mr",
                        containerIndex,
                        "Boring"
                      )
                    }
                    error={processTableErrors[rowIndex]?.mr}
                    helperText={
                      processTableErrors[rowIndex]?.mr
                        ? "This field is required"
                        : ""
                    }
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    label="NOH"
                    className="fixed-width-input"
                    size="small"
                    name={`noh-${rowIndex}`}
                    value={row.noh}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) =>
                      handleTextFieldChange(
                        e,
                        rowIndex,
                        "noh",
                        containerIndex,
                        "Boring"
                      )
                    }
                    error={processTableErrors[rowIndex]?.noh}
                    helperText={
                      processTableErrors[rowIndex]?.noh
                        ? "This field is required"
                        : ""
                    }
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    label="Required Dimension"
                    className="fixed-width-input"
                    size="small"
                    name={`requiredDimension-${rowIndex}`}
                    value={row?.requiredDimension}
                    onBlur={(e) =>
                      handleTextFieldChange(
                        e,
                        rowIndex,
                        "requiredDimension",
                        containerIndex,
                        "Boring"
                      )
                    }
                    onChange={(e) =>
                      handleTextFieldChange(
                        e,
                        rowIndex,
                        "requiredDimension",
                        containerIndex,
                        "Boring"
                      )
                    }
                    error={processTableErrors[rowIndex]?.requiredDimension}
                    helperText={
                      processTableErrors[rowIndex]?.requiredDimension
                        ? "This field is required"
                        : ""
                    }
                  />
                </TableCell>

                <TableCell align="center">
                  <TextField
                    label="NOP"
                    className="fixed-width-input"
                    size="small"
                    name={`nop-${rowIndex}`}
                    value={row.nop}
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    label="FPP"
                    className="fixed-width-input"
                    size="small"
                    name={`fpp-${rowIndex}`}
                    value={row.fpp}
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>

                <TableCell align="center">
                  <TextField
                    label="Estimated CT"
                    className="fixed-width-input"
                    size="small"
                    name={`estimatedCT-${rowIndex}`}
                    value={formatDecimalMinutesToMinutesSeconds(
                      row.estimatedCT
                    )}
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    label="Estimated Hrs"
                    className="fixed-width-input"
                    size="small"
                    name={`estimatedHrs-${rowIndex}`}
                    value={formatDecimalHoursToHoursMinutes(row.estimatedHrs)}
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell align="center">
                  <Tooltip title="Delete Row" arrow placement="top">
                    <IconButton
                      size="small"
                      onClick={() => handleDeleteRow(containerIndex, rowIndex)}
                    >
                      <ClearIcon color="error" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          <Button
            color="primary"
            sx={{
              backgroundColor: "#1d5393",
              color: "#fff",
              width: 100,
              margin: 3,
              "&:hover": {
                backgroundColor: "#245BA1",
              },
              "&:active": {
                backgroundColor: "#1d5393",
              },
            }}
            onClick={() => handleAddRow(containerIndex)}
          >
            Add Row
          </Button>
        </TableBody>
      </Table>
    </>
  );
}

export default BoringTable;
